import { Alert, Flex, Text } from "@fluentui/react-northstar";
import React, { useMemo, useState } from "react";

import { useUserInfo } from "../../../../_shared/actions/useUserInfo";
import { UsageMeter } from "../../../../_shared/components/MeterBars/UsageMeter";
import { useTeamsContext } from "../../../../_shared/state/TeamsContextProvider";
import { isMobileClient } from "../../../../_shared/utils/clientHelper";
import { isTrialAvailable, userIsOverWarningLimit } from "../../../../_shared/utils/userHelpers";
import { PlanUpgradeButton } from "./PlanUpgradeButton";

export const ResponseLimitBanner: React.FC<{ className?: string }> = ({ className }) => {
  const { user } = useUserInfo();
  const { teamsContext } = useTeamsContext();
  const [trialStartError] = useState<Error>();

  const showMeter = useMemo(
    () =>
      !user.subscriptions.some(s => s.state === "active" && s.type === "full") &&
      userIsOverWarningLimit(user),
    [user]
  );

  if (!showMeter) {
    return null;
  }

  const trialAvailable = isTrialAvailable(user, "msteams-standard");
  const isMobile = isMobileClient(teamsContext);

  return (
    <Flex gap="gap.medium" column className={className}>
      <UsageMeter user={user} />

      {user.usage > user.featureFlags.responseUsageLimit && (
        <Text
          content={`You have reached your response limit for the month. Upgrade ${
            trialAvailable ? "or start a trial" : ""
          } for more reponses!`}
          size="medium"
          align="center"
        />
      )}
      {!isMobile && (
        <Flex gap="gap.small">
          <PlanUpgradeButton
            trackingSource="meeting-sp-subscribe"
            dataTName="meeting-responselimit-banner-upgrade"
          />
          {trialAvailable && (
            <PlanUpgradeButton
              isTrial
              label="Start Trial"
              trackingSource="meeting-sp-subscribe-trial"
              dataTName="meeting-responselimit-banner-trial"
            />
          )}
        </Flex>
      )}
      {isMobile && (
        <Text size="medium" align="center">
          To continue using Polly please open Teams on your desktop
        </Text>
      )}

      {trialStartError && (
        <Alert danger content={`Unable to start a trial: ${trialStartError.message}`} />
      )}
    </Flex>
  );
};
